<ng-container *ngIf="subNavigationItems$ | async as subNavigationItems">
    <div *ngFor="let item of subNavigationItems; let i = index" class="table-container">
        <div>
            <div class="tree-head">
                <span class="tree-col">{{ item.name }}</span>
                <span class="tree-col adjustment" *ngIf="showAdjustments">
                    {{ 'aumico_reports_fcp_tree_adjustment_col_header' | i18next }}
                </span>
                <span class="tree-col current-year">{{ dueDateCY }}</span>
                <span class="tree-col">{{ dueDatePY ?? '-' }}</span>
            </div>
            <div class="tree-body">
                <div *ngFor="let child of item.children">
                    <ng-container [ngSwitch]="child.type">
                        <app-fcp-bundle-item
                            *ngSwitchCase="FcpTreeItemType.Bundle"
                            [item]="child"
                            [showAdjustments]="showAdjustments"
                            [outputFinStatements]="outputFinStatements"
                            [filter]="filter"
                        ></app-fcp-bundle-item>
                        <app-fcp-test-group-item
                            *ngSwitchCase="FcpTreeItemType.TestGroup"
                            [item]="child"
                            [showAdjustments]="showAdjustments"
                            [outputFinStatements]="outputFinStatements"
                            [filter]="filter"
                        ></app-fcp-test-group-item>
                        <app-fcp-test-item
                            *ngSwitchCase="FcpTreeItemType.TestItem"
                            [item]="child"
                            [showAdjustments]="showAdjustments"
                            [outputFinStatements]="outputFinStatements"
                            [filter]="filter"
                        ></app-fcp-test-item>
                        <!-- Default case if no match found -->
                        <div *ngSwitchDefault>{{ child.name }}</div>
                    </ng-container>
                </div>
            </div>
            <div class="tree-footer">
                <span class="tree-col">{{ item.name }}</span>
                <span class="tree-col adjustment" *ngIf="showAdjustments">
                    {{ subNavigationItemTotals[i].adjustedValue | finNumber }}</span
                >
                <span class="tree-col current-year">{{ subNavigationItemTotals[i].currentYear | finNumber }}</span>
                <span class="tree-col">{{ subNavigationItemTotals[i].previousYear | finNumber }}</span>
            </div>
        </div>
    </div>
</ng-container>
